var idmApiUrl = 'https://rn9tusj2i9.execute-api.us-east-1.amazonaws.com/test';

module.exports = {
    updateProfile: function(formData, accessToken) {
        var data = {
            identifiers: {
                email: [formData.email.value]
            },
            person: {
                firstName: formData.firstName.value
            },
            pii: {
                lastName: formData.lastName.value
            },
            sync: {
                clientTs: new Date().toISOString()
            },
            recordType: 'Aggregate'
        };

        return $.ajax({
            type: 'PUT',
            cache: false,
            url: idmApiUrl,
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json',
            beforeSend: function(req) {
                req.setRequestHeader('Authorization', accessToken);
            }
        });
    },

    getProfile: function(accessToken) {
        return $.ajax({
            type: 'GET',
            url: idmApiUrl,
            contentType: 'application/json',
            beforeSend: function(req) {
                req.setRequestHeader('Authorization', accessToken);
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/idm.js
// module id = 79
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14